const projects = {
    title: 'Projects',
    viewWork: 'View my work',
    viewAll: 'View all',
    pastWork: 'Past work',
    description: 'Take a look at my portfolio for an overview of my work.',
}

export default projects
